import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./SuccessHandler.sass";
import success_image from "../images/Illustration-success.png";
import { BASE } from "../basedata/constants";
import { apiUser } from "../basedata/apiCall";

import rgIcon from './../images/document_type.svg'
import cnhIcon from './../images/document_type_cnh.svg'
import { Box } from "@mui/material";


const DocumentReuse = () => {
  const { t } = useTranslation(); 

  const chooseDocument = async () => {
    const _current_token = sessionStorage.getItem('token')
    try{
      const _response = await apiUser.post(`/biometry/document/reuse`, {flowId: _current_token})
      if(_response.data?.status === 'success'){
        return window.location.href = '/success'
      }
      return window.location.href = '/mobile-document'
    }catch(e){
      console.log(e)
      return window.location.href = '/success'
    }
    return window.location.href = '/success'
  }


  return (
    <div className="success-container">
      <div className="progress-indicator">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="progress-bar"></div>
        ))}
      </div>
      <div className="left-side"></div> 
      <div className="right-side">
        <div className="success-card">
          <img className="logo" src={BASE.company.logo} alt={BASE.company.name} />
          <h1 className="success_title">
            {t("document_reuse.title")}
          </h1>
          <div className="success-message-container">
            <p className="success-message">
            <strong>
            {t("document_reuse.quote")}
            </strong> <br/><br/>
            </p>

        {/* <ul className="document-type-select">
      <li>
        <i>
          <img src={rgIcon} alt="icone documento"/>
        </i>
        <Box className="type-select-description">
          <h2 className="bepass-title">RG</h2>
          <p className="bepass-text-label">Documento de Identidade</p>
        </Box>
      </li>
        </ul> */}


            <p className="success-message">
            {t("document_reuse.text")}
            </p>

 
           <button onClick={() => chooseDocument()} className="continue-button"
    >
      {t("document_reuse.call_to_action_positive")}
    </button>

    <button onClick={() => {window.location.href = '/document-handler'}} className="continue-button btn-ghost"
    >
    {t("document_reuse.call_to_action_negative")}
    </button>


            <p className="document-reuse-disclaimer">
            {t("document_reuse.warning_text")} <a 
          href="https://storage.googleapis.com/companies-assets/bepass/bepass_terms.pdf" rel="noreferrer noopener" target="_blank"
          className="bold-link"
        >{t("document_reuse.warning_call_to_action")}</a>.
            </p>

          </div>
        </div>
      </div>
      {/* <footer className="success-footer">
        <div className="success-footer-logo"></div>
      </footer> */}
    </div>
  );
};

export default DocumentReuse;